import {useNotificationStore} from '@dafcoe/vue-notification';

const {setNotification} = useNotificationStore();

const notification = {
  defaultConfig: {
    'message': '',
    'type': '',
    'showIcon': true,
    'dismiss': {
      'manually': true,
      'automatically': true,
    },
    'duration': 3000,
    'showDurationProgress': true,
    'appearance': 'light',
  },

  error(message) {
    setNotification({
      ...this.defaultConfig,
      message,
      type: 'alert',
    });
  },

  success(message) {
    setNotification({
      ...this.defaultConfig,
      message,
      type: 'success',
    });
  },

  event(message) {
    setNotification({
      ...this.defaultConfig,
      message,
      type: 'info',
      duration: 5000
    });
  },

  warning(message) {
    setNotification({
      ...this.defaultConfig,
      message,
      type: 'warning',
      duration: 5000
    });
  },

  alarm(message) {
    setNotification({
      ...this.defaultConfig,
      message,
      type: 'alert',
      duration: 5000
    });
  }
};

export default notification;
